
import { useState } from "react";
import { Message } from "@/types/chat";

const WELCOME_MESSAGE: Message = {
  id: "welcome",
  text: "Ciao! Sono Gildy, il tuo assistente virtuale per l'oro e l'argento. Come posso aiutarti oggi?",
  isUser: false,
  timestamp: new Date()
};

export function useChatMessages() {
  const [messages, setMessages] = useState<Message[]>([WELCOME_MESSAGE]);
  const [inputValue, setInputValue] = useState("");
  const [suggestionsVisible, setSuggestionsVisible] = useState(true);

  const handleInputChange = (value: string) => {
    setInputValue(value);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      return true;
    }
    return false;
  };

  const handleSuggestionClick = (suggestion: string) => {
    setInputValue(suggestion);
    setSuggestionsVisible(false);
  };

  const addMessage = (message: Message) => {
    setMessages(prev => [...prev, message]);
  };

  const clearMessages = () => {
    setMessages([WELCOME_MESSAGE]);
  };

  const createUserMessage = (text: string): Message => ({
    id: `user-${Date.now()}`,
    text,
    isUser: true,
    timestamp: new Date()
  });

  return {
    messages,
    setMessages,
    inputValue,
    setInputValue: handleInputChange,
    suggestionsVisible,
    setSuggestionsVisible,
    handleKeyDown,
    handleSuggestionClick,
    addMessage,
    clearMessages,
    createUserMessage
  };
}
